import React from 'react';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import {withStyles} from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import settings from '../../icons/settings.png';
import lexicomp from '../../icons/lexicomp.png';
import stahls from '../../icons/stahls.png';
import { Radio } from 'antd';
import "./drawer.css";

const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;

const styles = {
  list: {
    width: 250
  },
  fullList: {
    width: 'auto'
  }
};

class LeftDrawer extends React.Component {

  state = {
    top: false,
    left: false,
    bottom: false,
    right: false
  };

  toggleDrawer = (side, open) => () => {
    this.setState({[side]: open});
  };

  render() {
    const {classes, type, va} = this.props;
    return (<div className='button-div'>
      {/* <button onClick={this.toggleDrawer('left', true)}>
        <img className='appbar-button' src={settings} alt="settings"></img>
        <div>Display</div>
      </button> */}
      <SwipeableDrawer open={this.state.left} onClose={this.toggleDrawer('left', false)} onOpen={this.toggleDrawer('left', true)}>
        <div tabIndex={0} role="button" onClick={this.toggleDrawer('left', false)} onKeyDown={this.toggleDrawer('left', false)}></div>
        <div className={classes.fullList}>
          <List>
            <ListItem>
              <span className="drawer-title">
                View Settings
              </span>
            </ListItem>
            {(type==="hypertension"||type==="diabetes")?
            (<ListItem>
            <ListItemText primary="View"/>
            <RadioGroup defaultValue={this.props.switchOption} onChange={this.props.handleSwitch} size="large">
              <RadioButton value={false}>Pills</RadioButton>
              <RadioButton value={true}>Classes</RadioButton>
            </RadioGroup>
            </ListItem>): ""}
            {/* <ListItem>
            <ListItemText primary="Language"/>
            <RadioGroup defaultValue={this.props.language} onChange={this.props.handleLanguage} size="large">
              <RadioButton value="eng">English</RadioButton>
              <RadioButton value="es">Spanish</RadioButton>
            </RadioGroup>
            </ListItem> */}
            <ListItem>
            <ListItemText primary="Cost"/>
            <RadioGroup defaultValue={this.props.cost[this.props.costIndex]} onChange={this.props.handleCost} size="large">
              {va===true?  <RadioButton value="va_formulary">VA Formulary</RadioButton> : <RadioButton value="medicaid">Medicaid</RadioButton>}
              <RadioButton value="prices">Prices</RadioButton>
            </RadioGroup>
            </ListItem>
            <ListItem>
            <ListItemText primary="FDA or Off Label"/>
            <RadioGroup defaultValue={this.props.treatTypes[this.props.treatsIndex]} onChange={this.props.handleTreat} size="large">
              <RadioButton value="fda">FDA</RadioButton>
              <RadioButton value="offlabel">Off-Label</RadioButton>
            </RadioGroup>
            </ListItem>
          </List>
            <div className="logo-center-children">
                <img className="logos logo1" src={stahls}/>
            </div>
            <div className="logo-center-children">
                <img className="logos logo2" src={lexicomp}/>
            </div>
        </div>
        {this.props.children}
      </SwipeableDrawer>
    </div>);
  }
}

export default withStyles(styles)(LeftDrawer);



// WEBPACK FOOTER //
// ./src/NavBar/LeftDrawer/index.js